import { useInterpolatedTranslationKey } from '@dreryk/react-common';
import { FormLabel } from '@dreryk/react-components';

import { sentPrescriptionPackagesTranslationKeys } from '../../../../translations';

type PrescriptionPackageViewHeadingProps = {
   readonly packageNumber: number;
};

export const PrescriptionPackageViewHeading = (props: PrescriptionPackageViewHeadingProps): JSX.Element => {
   const { packageNumber } = props;
   return (
      <FormLabel
         testId={'packageNumber'}
         label={useInterpolatedTranslationKey(sentPrescriptionPackagesTranslationKeys.packageNumber, {
            packageNumber: packageNumber,
         })}
      />
   );
};
